!function(){

// ── Fetch intercept ─────────────────────────────────────────────────────────
// Enhancify builder bug: inventory_policy=continue + quantityAvailable=0
// shows "OUT OF STOCK" instead of "Pre-Order (Expected: date)".
// Fix: intercept Storefront API GraphQL responses and change quantityAvailable
// from 0 → -1 when availableForSale=true (continue-selling variant).
// The builder already handles -1 correctly; we just make 0 look like -1.
(function(){
  var orig=window.fetch;
  window.fetch=function(url,opts){
    var p=orig.apply(this,arguments);
    try{
      var u=url&&url.toString?url.toString():'';
      if(u.indexOf('graphql')!==-1){
        return p.then(function(res){
          if(!res||!res.ok)return res;
          return res.clone().json().then(function(data){
            if(!patchQty(data))return res;
            return new Response(JSON.stringify(data),{
              status:res.status,
              statusText:res.statusText,
              headers:{'Content-Type':'application/json'}
            });
          }).catch(function(){return res;});
        }).catch(function(){return p;});
      }
    }catch(e){}
    return p;
  };
  function patchQty(obj){
    if(!obj||typeof obj!=='object')return false;
    if(Array.isArray(obj)){
      var m=false;obj.forEach(function(i){if(patchQty(i))m=true;});return m;
    }
    var mod=false;
    if('quantityAvailable'in obj&&obj.quantityAvailable===0&&obj.availableForSale===true){
      obj.quantityAvailable=-1;mod=true;
    }
    Object.keys(obj).forEach(function(k){if(patchQty(obj[k]))mod=true;});
    return mod;
  }
})();

// ── CSS ─────────────────────────────────────────────────────────────────────
var s=document.createElement('style');
s.textContent='body.dogg-modal .custom-builder__component-detail-page:not(.is-hidden){position:fixed!important;top:50%!important;left:50%!important;transform:translate(-50%,-50%)!important;width:min(900px,90vw)!important;max-height:85vh!important;overflow-y:auto!important;z-index:10000!important;background:#fff!important;border-radius:8px!important;box-shadow:0 0 0 9999px rgba(0,0,0,.65),0 25px 50px rgba(0,0,0,.3)!important}body.dogg-modal .custom-builder__component-detail-page__back-container{position:sticky!important;top:0!important;background:#fff!important;z-index:1!important;padding:12px 16px!important;border-bottom:1px solid #eee!important;display:flex!important;justify-content:flex-end!important}.dogg-desc-ov{font-size:inherit;line-height:1.6;white-space:pre-line}.randomising-overlay{display:flex!important;align-items:center!important;justify-content:center!important}.randomising-overlay-content{display:flex!important;flex-direction:column!important;align-items:center!important;text-align:center!important}.randomising-overlay-wheel{margin:0 auto!important}';
document.head.appendChild(s);

// ── Description injection ────────────────────────────────────────────────────
var cache={};
function apply(html){
  var d=document.querySelector('div[data-product-description]');
  if(!d)return;
  d.style.display='none';
  var ov=d.parentElement&&d.parentElement.querySelector('.dogg-desc-ov');
  if(ov){ov.innerHTML=html;return;}
  ov=document.createElement('div');ov.className='dogg-desc-ov';ov.innerHTML=html;
  if(d.parentElement)d.parentElement.insertBefore(ov,d);
}
function cleanupDesc(){
  var d=document.querySelector('div[data-product-description]');
  if(d)d.style.display='';
  var ov=document.querySelector('.dogg-desc-ov');
  if(ov)ov.remove();
}
function injectDesc(attempt){
  var titleEl=document.querySelector('.custom-builder__component-detail-page:not(.is-hidden) .product-title');
  if(!titleEl){if((attempt||0)<15)setTimeout(function(){injectDesc((attempt||0)+1);},200);return;}
  var title=titleEl.textContent.trim();
  if(cache[title]!==undefined){if(cache[title])apply(cache[title]);return;}
  cache[title]=null;
  fetch('/search/suggest.json?q='+encodeURIComponent(title)+'&resources%5Btype%5D=product&resources%5Blimit%5D=3')
    .then(function(r){return r.json();})
    .then(function(j){
      var prods=j.resources&&j.resources.results&&j.resources.results.products;
      if(!prods||!prods.length)return;
      var handle=(prods[0].url||'').split('/products/')[1]||prods[0].handle;
      if(!handle)return;
      return fetch('/products/'+handle+'?sections%5B%5D=dogg-builder-description')
        .then(function(r){return r.json();})
        .then(function(j2){var html=j2['dogg-builder-description'];if(!html)return;cache[title]=html;apply(html);});
    }).catch(function(){});
}

// ── Modal open/close ─────────────────────────────────────────────────────────
var savedT=[];
function openModal(dt){
  var el=dt.parentElement;
  while(el&&el!==document.documentElement){
    var cs=window.getComputedStyle(el);
    if(cs.transform&&cs.transform!=='none'){savedT.push({el:el,v:el.style.transform});el.style.transform='none';}
    el=el.parentElement;
  }
  document.body.classList.add('dogg-modal');
  document.addEventListener('click',outsideClick,true);
  setTimeout(function(){injectDesc(0);},50);
}
function closeModal(){
  document.body.classList.remove('dogg-modal');
  savedT.forEach(function(o){o.el.style.transform=o.v;});
  savedT=[];
  document.removeEventListener('click',outsideClick,true);
  cleanupDesc();
}
function outsideClick(e){
  var dt=document.querySelector('.custom-builder__component-detail-page:not(.is-hidden)');
  if(dt&&!dt.contains(e.target)){e.stopPropagation();var b=dt.querySelector('.btn--close');if(b)b.click();}
}

// ── Pre-order badge colour (card grid) ───────────────────────────────────────
function fixPreOrderColor(){
  var root=document.querySelector('[data-app-layer-portal]')||document.body;
  root.querySelectorAll('.component-product-card__image-oos').forEach(function(el){
    if(/^EXPECTED/i.test((el.textContent||'').trim())){
      el.style.setProperty('background-color','#9333ea','important');
      el.style.setProperty('color','#fff','important');
      el.style.setProperty('border-color','#9333ea','important');
    }
  });
}
setTimeout(fixPreOrderColor,500);
setTimeout(fixPreOrderColor,1500);
setTimeout(fixPreOrderColor,3000);

// ── MutationObserver ─────────────────────────────────────────────────────────
new MutationObserver(function(){
  fixPreOrderColor();
  var dt=document.querySelector('.custom-builder__component-detail-page');
  if(!dt)return;
  var open=!dt.classList.contains('is-hidden');
  var active=document.body.classList.contains('dogg-modal');
  if(open&&!active)openModal(dt);
  else if(!open&&active)closeModal();
}).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});

}();